export default [
  {
    path: 'videoManager',
    name: 'videoManager',
    component: () => import('./videoManager'),
  }
];



// WEBPACK FOOTER //
// ./src/views/applet/index.route.js